// Dela varukorg — skapa/maila delad varukorg + lägg alla i cart på delad-varukorg-sidan.
// Modalen öppnas/stängs via temats befintliga modal-system (src/js/utils/modal.js).

function getAjaxUrl() {
    return (window.liGlobal && window.liGlobal.ajaxUrl) || '/wp-admin/admin-ajax.php'
}

function getModal() {
    return document.querySelector('[data-modal_id="share-cart"]')
}

function setMsg(el, text, type) {
    if (!el) return
    el.textContent = text || ''
    el.className = 'text-sm m-0'
    if (type === 'success') el.classList.add('text-green-700')
    if (type === 'error') el.classList.add('text-red-700')
}

async function postAjax(action, data = {}) {
    const body = new URLSearchParams()
    body.set('action', action)
    Object.keys(data).forEach((k) => body.set(k, data[k] == null ? '' : data[k]))

    const res = await fetch(getAjaxUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: body.toString(),
    })
    return res.json()
}

async function copyToClipboard(text) {
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text)
            return true
        }
    } catch (err) {
        // fallback nedan
    }
    const input = document.createElement('textarea')
    input.value = text
    input.style.position = 'fixed'
    input.style.left = '-1000px'
    document.body.appendChild(input)
    input.select()
    try {
        document.execCommand('copy')
        return true
    } catch (err) {
        return false
    } finally {
        document.body.removeChild(input)
    }
}

// Lyssna på när modal-knappen klickas. Modal.js sätter .active först, sedan kör vi init.
document.addEventListener(
    'click',
    function (e) {
        const toggle = e.target.closest('[data-toggle_modal="share-cart"]')
        if (!toggle) return

        // Om modal är på väg att öppnas (inte redan active), initiera innehåll.
        // Timeout för att låta modal.js hinna sätta .active.
        setTimeout(async () => {
            const modal = getModal()
            if (!modal || !modal.classList.contains('active')) return

            const linkInput = modal.querySelector('#lw-share-cart-link')
            const copyBtn = modal.querySelector('#lw-share-cart-copy')
            const msgEl = modal.querySelector('#lw-share-cart-msg')

            // Regenerera varje gång modal öppnas (varukorgens innehåll kan ha ändrats).
            if (linkInput) linkInput.value = ''
            if (copyBtn) copyBtn.disabled = true
            setMsg(msgEl, '', '')

            try {
                const resp = await postAjax('lw_create_shared_cart')
                if (resp && resp.success && resp.data && resp.data.url) {
                    modal.dataset.token = resp.data.token
                    if (linkInput) linkInput.value = resp.data.url
                    if (copyBtn) copyBtn.disabled = false
                } else {
                    setMsg(msgEl, (resp && resp.data && resp.data.msg) || 'Kunde inte skapa delad varukorg.', 'error')
                }
            } catch (err) {
                setMsg(msgEl, 'Kunde inte skapa delad varukorg.', 'error')
            }
        }, 0)
    },
    true
)

// Kopiera länk
document.addEventListener('click', async function (e) {
    const copyBtn = e.target.closest('#lw-share-cart-copy')
    if (!copyBtn) return
    e.preventDefault()

    const modal = getModal()
    const linkInput = modal && modal.querySelector('#lw-share-cart-link')
    if (!linkInput || !linkInput.value) return

    const ok = await copyToClipboard(linkInput.value)
    const label = copyBtn.dataset.defaultLabel || copyBtn.textContent.trim()
    copyBtn.dataset.defaultLabel = label
    copyBtn.textContent = ok ? 'Kopierat!' : 'Kunde inte kopiera'
    setTimeout(() => {
        copyBtn.textContent = label
    }, 1800)
})

// Skicka e-post
document.addEventListener('submit', async function (e) {
    const form = e.target.closest('#lw-share-cart-form')
    if (!form) return
    e.preventDefault()

    const modal = getModal()
    const msgEl = modal && modal.querySelector('#lw-share-cart-msg')
    const token = modal && modal.dataset.token
    const labelEl = form.querySelector('.lw-share-cart-submit-label')
    const loadingEl = form.querySelector('.lw-share-cart-submit-loading')
    const submitBtn = form.querySelector('button[type="submit"]')

    if (!token) {
        setMsg(msgEl, 'Ingen delad varukorg att skicka.', 'error')
        return
    }

    const to = form.querySelector('#lw-share-cart-to').value.trim()
    const fromName = form.querySelector('#lw-share-cart-from-name').value.trim()
    const message = form.querySelector('#lw-share-cart-message').value.trim()

    if (!to) {
        setMsg(msgEl, 'Ange en e-postadress.', 'error')
        return
    }

    submitBtn.disabled = true
    if (labelEl) labelEl.classList.add('hidden')
    if (loadingEl) loadingEl.classList.remove('hidden')
    setMsg(msgEl, '', '')

    try {
        const resp = await postAjax('lw_email_shared_cart', {
            token,
            to,
            from_name: fromName,
            message,
        })
        if (resp && resp.success) {
            setMsg(msgEl, (resp.data && resp.data.msg) || 'Mejlet har skickats.', 'success')
            form.reset()
        } else {
            setMsg(msgEl, (resp && resp.data && resp.data.msg) || 'Kunde inte skicka mejlet.', 'error')
        }
    } catch (err) {
        setMsg(msgEl, 'Kunde inte skicka mejlet.', 'error')
    } finally {
        submitBtn.disabled = false
        if (labelEl) labelEl.classList.remove('hidden')
        if (loadingEl) loadingEl.classList.add('hidden')
    }
})

function lwWcAjaxUrl(endpoint) {
    const tpl = (window.wc_add_to_cart_params && window.wc_add_to_cart_params.wc_ajax_url) || '/?wc-ajax=%%endpoint%%'
    return tpl.replace('%%endpoint%%', endpoint)
}

// Hämta fragmenter från WC och uppdatera mini-carten (samma flöde som mini-cart.js refreshMiniCart).
function refreshMiniCartFragments() {
    if (!window.jQuery) return Promise.resolve()
    const $ = window.jQuery

    return new Promise((resolve) => {
        $.ajax({
            url: lwWcAjaxUrl('get_refreshed_fragments'),
            type: 'POST',
            beforeSend: function () {
                $(document.body).trigger('wc_fragment_refresh')
            },
            success: function (data) {
                if (!data || !data.fragments) {
                    resolve()
                    return
                }

                $.each(data.fragments, function (selector, html) {
                    if (selector === 'total_count') return
                    $(selector).replaceWith(html)
                })

                const hasItems = data.fragments.total_count > 0
                if (hasItems) {
                    $('.checkout-button').removeClass('disabled')
                    $('.lw-share-cart-btn').removeClass('hidden')
                } else {
                    $('.checkout-button').addClass('disabled')
                    $('.lw-share-cart-btn').addClass('hidden')
                }

                $(document.body).trigger('wc_fragments_refreshed', [data.fragments])
                $(document.body).trigger('wc_fragments_loaded', [data.fragments])
                $(document.body).trigger('cart_totals_refreshed')
                resolve()
            },
            error: function () {
                if (window.jQuery) $(document.body).trigger('wc_fragments_ajax_error')
                resolve()
            },
        })
    })
}

// "Lägg alla i min varukorg"-knappen på delad-varukorg-sidan.
document.addEventListener('click', async function (e) {
    const btn = e.target.closest('#lw-add-shared-cart-btn')
    if (!btn) return
    e.preventDefault()

    const token = btn.dataset.token
    const msgEl = document.getElementById('lw-shared-cart-msg')
    const labelEl = btn.querySelector('.lw-add-shared-cart-label')
    const loadingEl = btn.querySelector('.lw-add-shared-cart-loading')

    if (!token) return

    btn.disabled = true
    if (labelEl) labelEl.classList.add('hidden')
    if (loadingEl) loadingEl.classList.remove('hidden')
    setMsg(msgEl, '', '')

    try {
        const resp = await postAjax('lw_add_shared_cart_to_cart', { token })

        if (!resp || !resp.success) {
            setMsg(msgEl, (resp && resp.data && resp.data.msg) || 'Kunde inte lägga till i varukorgen.', 'error')
            return
        }

        await refreshMiniCartFragments()

        setMsg(msgEl, resp.data.msg || 'Tillagt i varukorgen.', 'success')

        // Öppna mini-carten efter kort delay.
        setTimeout(() => {
            const dropdown = document.getElementById('mini-cart-dropdown')
            if (dropdown && dropdown.parentElement) {
                dropdown.parentElement.classList.add('active')
                document.body.classList.add('mini-cart-open')
            }
        }, 300)
    } catch (err) {
        setMsg(msgEl, 'Kunde inte lägga till i varukorgen.', 'error')
    } finally {
        btn.disabled = false
        if (labelEl) labelEl.classList.remove('hidden')
        if (loadingEl) loadingEl.classList.add('hidden')
    }
})
